import { render, staticRenderFns } from "./DosageForm.vue?vue&type=template&id=6dc582d4&scoped=true"
import script from "./DosageForm.vue?vue&type=script&lang=js"
export * from "./DosageForm.vue?vue&type=script&lang=js"
import style0 from "./DosageForm.vue?vue&type=style&index=0&id=6dc582d4&prod&lang=scss&scoped=true"
import style1 from "./DosageForm.vue?vue&type=style&index=1&id=6dc582d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc582d4",
  null
  
)

export default component.exports